import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Content from './content';
import Footer from './footer';
import Modals from './modals';
import Navbar from './navbar';
import Sidebar from './sidebar';

class Layout extends PureComponent {
  static propTypes = {
    history: PropTypes.object,
    isAuth: PropTypes.bool,
  };

  componentDidMount() {
    if (!this.props.isAuth) {
      this.props.history?.push?.('/login');
    }
  }

  render() {
    return (
      <div className="hold-transition layout-fixed layout-footer-fixed layout-navbar-fixed sidebar-mini">
        <div className="wrapper">
          <Navbar />
          <Sidebar />
          <Content />
          <Footer />
          <Modals />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  isAuth: !!state?.auth?.api_token,
});

export default connect(mapStateToProps)(Layout);
